import StudyReportPage from '@/features/studies/report/page/StudyReportPage'

export function StudyReportRoute() {
  return <StudyReportPage />
}

export default StudyReportRoute
